/** Default when REACT_APP_PUBLIC_INFO_EMAIL is unset at build time */
const DEFAULT_PUBLIC_INFO_EMAIL = "info@demaxtore.com";

const infoEmailFromEnv = (process.env.REACT_APP_PUBLIC_INFO_EMAIL || "").trim();

/**
 * Shown in footer and contact block (public “info” address).
 * Override with REACT_APP_PUBLIC_INFO_EMAIL in `.env` if needed.
 */
export const PUBLIC_INFO_EMAIL = infoEmailFromEnv || DEFAULT_PUBLIC_INFO_EMAIL;

export const PUBLIC_INFO_MAILTO_HREF = `mailto:${PUBLIC_INFO_EMAIL}`;

/** Default line when REACT_APP_PUBLIC_PHONE is unset at build time */
const DEFAULT_PUBLIC_PHONE = "+90 541 113 50 09";

const fromEnv = (process.env.REACT_APP_PUBLIC_PHONE || "").trim();

/**
 * Shown in footer and contact block.
 * Override with REACT_APP_PUBLIC_PHONE in `.env` if needed.
 */
export const PUBLIC_PHONE_DISPLAY = fromEnv || DEFAULT_PUBLIC_PHONE;

/**
 * `tel:` href for one-tap dial (digits from {@link PUBLIC_PHONE_DISPLAY}).
 * Empty if there are too few digits.
 */
export const PUBLIC_PHONE_TEL_HREF = (() => {
  const digits = PUBLIC_PHONE_DISPLAY.replace(/\D/g, "");
  if (digits.length < 10) return "";
  return `tel:+${digits}`;
})();

/** Registered headquarters (Istanbul). */
export const COMPANY_ADDRESS_HEADQUARTERS =
  "Delta Business Center B1 Block 9th Floor 18th Office Beylikdüzü / Istanbul - TURKEY";

/** Branch office (İzmir). */
export const COMPANY_ADDRESS_OFFICE =
  "Kültür Street Aliçetinkaya Boulevard No 37 Başarı Building 6th Floor Alsancak / İzmir - TURKEY";
